<template>
<div>

  <div v-if="!errored">

    <div class="d-flex flex-wrap mx-auto" style="max-width: 900px;">

        <div v-for="item in photos" :key="item.id" class="m-2">

            <b-card  class="mx-auto" footer-tag="footer" style="max-width: 360px;">
              <b-card-text >

                <span v-if="item.remarks"> 
                  <b-link :id="item.id" href="#" disbaled> <strong>{{ item.caption }}...</strong> </b-link>
                </span>
                <span v-else> 
                  <strong>{{ item.caption }}</strong> 
                </span>

              </b-card-text>
              <b-button variant="outline-light" class="p-0"  @click="showPhoto(item.blobUrl)">
                <b-card-img :src="'data:image/jpeg;base64,' + item.thumbnail" img-alt="photo" bottom>  </b-card-img>
             </b-button>
              <template v-slot:footer>
                <b-link :to="{ name: 'StandaloneJournal', params:{ id: item.projectId, date: dateString(item.journalDate) } }" class="card-link">Journal: {{item.journalDate | moment("MMMM Do YYYY") }}</b-link>
              </template>
            </b-card>

            <b-popover placement="right" v-if="item.remarks" :target="item.id" triggers="hover">
              {{item.remarks}}
            </b-popover>

        </div>

        <div v-if="photocount==0" class="mx-auto pt-3"> (No Photos) </div>

    </div>

         <a v-if="photos.length>4" class="pr-5 pb-3" href="#"> <b> ^ top </b> </a>  

        <b-button class="my-3" v-if="photocount>0 & photos.length<photocount" 
          @click="load"> Show more... <b-spinner small v-if="isBusy" class="mx-2"></b-spinner> 
        </b-button> 

  </div>

  <div v-if="isBusy" id="overlay">
       <b-spinner style="width: 2rem; height: 2rem;" > </b-spinner>
  </div>

  <div v-if="errored">
    <p class="text-danger">An error occurred loading data.</p>
    <p>{{ error }}</p>
  </div>

      <!-- The modal showPhoto -->
    <b-modal v-bind:id="'show-photo'+projectId" size="xl" hide-footer>
      <div v-if="!photoLoaded" class="text-center">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <b-img v-show="photoLoaded" :src="imgSrc" v-on:load="onLoaded" @error="onImageError" fluid></b-img>
      <div v-if="imageError">
        <b-alert class="text-center" show variant="danger">Error loading image.</b-alert>
      </div>
    </b-modal>


</div>
</template>

<script>
export default {
    name: "JournalPhotos",
    data: function() {
        return {
            project: null, 
            projectId: this.$route.params.id,
            photos: [],
            photocount: -1,
            isBusy: false,
            errored: false,
            imgSrc: "",
            photoLoaded: false,
            imageError: false,
            photo: null,
            Sas: ""
        };
    },
 
  mounted() {
     this.fetchPhotos(0,4);
       
    },
   

  methods: {

     fetchPhotos(skip,take) {
      this.isBusy = true;
      this.$auth.acquireToken().then(token => {
          this.$http
          .get("api/ProjectPhotos/" + this.projectId + "/" + skip + "/" + take, {
            headers: { Authorization: "Bearer " + token }
          })
        .then(response => {
          this.photocount = response.data.count;
          this.photos.push.apply(this.photos,response.data.results);

        })
        .catch(error => {
          console.log(error);
          this.errored = true;
          if (error.response) {this.error = error.response.statusText};
        })
        .finally(() => {
          this.isBusy = false;
          //console.log("done fetchPhotos!");
        });
      });
    },

    load(){
      this.fetchPhotos(this.photos.length,4);
    },
    
    dateString(dte){
      return this.$moment(dte).format("YYYYMMDD");
    },

    showPhoto(url) {
      this.photoLoaded = false;
      this.imageError = false;

      if (this.Sas)
        {
          this.$bvModal.show("show-photo" + this.projectId);
          this.imgSrc = url+this.Sas;
        }
      else
       {
        this.$auth.acquireToken().then(token => {
        this.$http.get(
        "api/ContainerSas",
        {
          headers: { Authorization: "Bearer " + token }
        }
        )
        .then(response => {
          this.Sas = response.data;
          this.$bvModal.show("show-photo" + this.projectId);
          this.imgSrc = url+this.Sas;
        })
       });
      }
    },    

    onImageError(e) {
      console.log(e);
      //to-do: consider refresh Sas token to handle if error is 404?
      this.isBusy = false;
      this.photoLoaded = true;
      this.imageError = true;
    },

    onLoaded() {
      this.isBusy = false;
      this.photoLoaded = true;
    }


  }

}

</script>

<style>

#overlay {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

</style>
